import { useEffect, useState } from "react"
import * as api from '../../../../Auth/auth'
import SectionVaccsCard1 from "../SectionVaccsCard1";

export default function GetVaccCounts() {
  
       const [data, setData] = useState({TOTAL: 0})

      useEffect(() => {

        async function axios_get() {
            const response = await api.vaccCountFetch()
            const vaccValues = response
            setData(vaccValues);
            
            
            }

        axios_get()
         
        }, []);
        
        const vaccValue = [data.TOTAL]
       
    return (
        
             <div> 
                     <SectionVaccsCard1 data={vaccValue} />;  
                
            </div>
        )
    }
    